import { useTranslations } from 'next-intl';

import { getSearchURL } from '@commons/components/Search/routing';
import Tag from '@commons/components/Tag';
import type { DrupalTerm } from '@commons/types/drupal';
import { ALGOLIA_INDEX_REPLICA_DESC } from '@commons/utils/constants';

/**
 * InsightTopic Term component.
 *
 * Links to the insights search page with the topic filter applied.
 */

const InsightTopicTerm = ({ name }: DrupalTerm) => {
  const t = useTranslations('search.path');

  const searchURL = getSearchURL(t('insights'), {
    index: ALGOLIA_INDEX_REPLICA_DESC,
    filters: { '[refinementList][topics][0]': name },
  });

  return (
    <Tag variant="tertiary" link={searchURL}>
      {name}
    </Tag>
  );
};

export default InsightTopicTerm;
